import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { FilterModel } from 'src/app/pages/common-models/common.model';
import { CustomValidators } from 'src/app/services/error-message/custom-validators';
import { SharedService } from 'src/app/services/shared.service';
import { LabClientsService } from '../../client-admin/clients/clients.service';


@Component({
  selector: 'app-patient-log',
  templateUrl: './patient-log.component.html',
  styleUrls: ['./patient-log.component.scss']
})
export class PatientLogDialogComponent implements OnInit {
  dataList: any = [];
  dataModel = new FilterModel();
  customFilter = '';
  pageSettings: PageSettingsModel;
  isFromPatient = false;

  constructor(
    private dialogRef: MatDialogRef<PatientLogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private labClientsService: LabClientsService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.pageSettings = this.sharedService.resetPageSettings();
    if (this.data && this.data.isFromPatient) {
      this.isFromPatient = this.data.isFromPatient;
    }
    this.refreshData();
  }

  refreshData() {
    this.dataModel = new FilterModel();
    this.customFilter = '';
    this.getLogs();
  }

  getLogs() {
    if (this.isFromPatient) {
      this.labClientsService.getPatientlogs(this.data.id).subscribe(data => {
        if (data && data.length > 0) {
          data.forEach(element => {
            element.viewDate = CustomValidators.DateConvert(element.createdDateTime);
          });
          this.dataList = data;
        }
      });
    } else {
      this.sharedService.getEjsGridData(this.labClientsService.labClientlogs(this.data.id, this.dataModel, this.customFilter)).subscribe(data => {
        this.dataList = data;
      });
    }
  }

  dataStateChange(state) {
    this.sharedService.dataStateChange(state, this.dataModel).then(res => {
      this.dataModel.PageSize = res.dataModel.PageSize;
      this.dataModel.StartPageNo = res.dataModel.StartPageNo;
      this.dataModel.SortExpression = res.dataModel.SortExpression;
      if (res.pageSettings) {
        this.pageSettings = res.pageSettings;
      }
      this.customFilter = this.sharedService.setCustomFilter(state);
      this.getLogs();
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
